import '@expo/metro-runtime';
import React from 'react';
import { usePreventPageZoom } from 'src/hooks/usePreventPageZoom';
import { TRouteComponent } from './_shared/routes.types';
import { BottomSheetProvider } from '@photosi/rn-components/bottom-sheet-provider/BottomSheetProvider';
import UploadV3 from 'src/screen/upload-v3/UploadV3';

export const UploadV3Route: TRouteComponent = () => {
  usePreventPageZoom();

  return (
    <BottomSheetProvider>
      <UploadV3 />
    </BottomSheetProvider>
  );
};
